module.exports = __webpack_public_path__ + "static/media/0028_L_ESPACE_RESTAURATION_MAIL.e068e469.webp";